module.exports = __webpack_public_path__ + "static/media/celinedion_natal.15bfab07.jpg";